import { Languages } from "../../types";
import { createServiceDictionary } from "./CreateService";
import { createServiceCategoryDictionary } from "./CreateServiceCategory";
import { servicessDictionary } from "./Services";
import { serviceCategoriesDictionary } from "./ServicesCategories";
import { ServicePagesDescriptions } from "./types";

export const getServiceDescriptions = (systemLang: Languages): ServicePagesDescriptions => ({
    SERVICES: servicessDictionary[systemLang],
    CREATE: createServiceDictionary[systemLang],
    SERVICE_CATEGORIES: serviceCategoriesDictionary[systemLang],
    CREATE_SERVICE_CATEGORY: createServiceCategoryDictionary[systemLang],
})